module.exports = __webpack_public_path__ + "static/logo-vertical-light-500x410-f3e48d1fb541b6c6878257997f54e05f.png";